module.exports = __webpack_public_path__ + "eb88b6e487e6ca7f89970833df03b645.png";